import fbIcon from '@/assets/icons/fb-icon.png'
import instagramIcon from '@/assets/icons/instagram.png'
import twitterIcon from '@/assets/icons/twitter.png'
import discordIcon from '@/assets/icons/discord.png'
import tiktokIcon from '@/assets/icons/tiktok.png'
import youtubeIcon from '@/assets/icons/youtube.png'
import emailIcon from '@/assets/icons/email.png'
import v1Icon from '@/assets/icons/vip1.png'
import v2Icon from '@/assets/icons/vip2.png'
import v3Icon from '@/assets/icons/vip3.png'
import v4Icon from '@/assets/icons/vip4.png'
import v5Icon from '@/assets/icons/vip5.png'
import v6Icon from '@/assets/icons/vip6.png'
import v7Icon from '@/assets/icons/vip7.png'
import v8Icon from '@/assets/icons/vip8.png'
import v9Icon from '@/assets/icons/vip9.png'
import v10Icon from '@/assets/icons/vip10.png'
import v11Icon from '@/assets/icons/vip11.png'
import v12Icon from '@/assets/icons/vip12.png'
import v13Icon from '@/assets/icons/vip13.png'
import v14Icon from '@/assets/icons/vip14.png'
import v15Icon from '@/assets/icons/vip15.png'
import v16Icon from '@/assets/icons/vip16.png'
import { CurrentCountryType, CurrentLanguageType } from '@/store/modules/language'

interface Config {
  url: string
  key: string
  icon: string
}

export interface CONTACT_US_CONFIG_TYPE {
  [key: string]: Config[]
}

export const CONTACT_US_CONFIG: CONTACT_US_CONFIG_TYPE = {
  '/lios': [
    {
      key: 'facebook',
      icon: fbIcon,
      url: 'https://www.facebook.com/LastDayRules'
    },
    {
      key: 'instagram',
      url: 'https://www.instagram.com/lastisland_official/',
      icon: instagramIcon
    },
    {
      key: 'twitter',
      url: 'https://twitter.com/home?lang=en',
      icon: twitterIcon
    },
    {
      key: 'discord',
      url: 'https://discord.gg/liosofficial',
      icon: discordIcon
    },
    {
      key: 'tiktok',
      url: 'https://www.tiktok.com/@lios_official_',
      icon: tiktokIcon
    },
    {
      key: 'youtube',
      url: 'https://www.youtube.com/@LIOSofficial',
      icon: youtubeIcon
    }
  ],
  '/dhtw': [
    {
      key: 'facebook',
      icon: fbIcon,
      url: 'https://www.facebook.com/dragonhunttw'
    },
    {
      key: 'instagram',
      icon: instagramIcon,
      url: 'https://www.instagram.com/dragonhunttw/'
    },
    {
      key: 'youtube',
      icon: youtubeIcon,
      url: 'https://www.youtube.com/channel/UC4tvKL6bNuHx--jAq_qJKqw'
    },
    {
      key: 'discord',
      icon: discordIcon,
      url: 'https://discord.gg/DRKcH8hU7u'
    },
    {
      key: 'email',
      icon: emailIcon,
      url: 'mailto:dhasia@dinogame.com.tw'
    },
    {
      key: 'tiktok',
      icon: tiktokIcon,
      url: 'https://www.tiktok.com/@dragonhunt_tw'
    }
  ],
  '/twwtb': [
    {
      key: 'facebook',
      icon: fbIcon,
      url: 'https://www.facebook.com/utopiaorigintw'
    },
    {
      key: 'youtube',
      icon: youtubeIcon,
      url: 'https://www.youtube.com/@UtopiaOrigin'
    },
    {
      key: 'email',
      icon: emailIcon,
      url: 'mailto:utopia@herogame.com'
    }
  ],
  '/twee': [
    {
      key: 'facebook',
      icon: fbIcon,
      url: 'https://www.facebook.com/EternalEvolutionOfficial'
    },
    {
      key: 'youtube',
      icon: youtubeIcon,
      url: 'https://www.youtube.com/@eternalevolution'
    },
    {
      key: 'discord',
      icon: discordIcon,
      url: 'https://discord.gg/Wh9NaD9Bb7'
    },
    {
      key: 'instagram',
      icon: instagramIcon,
      url: 'https://www.instagram.com/eternalevolution.official/'
    },
    {
      key: 'twitter',
      icon: twitterIcon,
      url: 'https://twitter.com/EternalEvoluti4'
    },
    {
      key: 'tiktok',
      icon: tiktokIcon,
      url: 'https://www.tiktok.com/@eternal_evolution'
    }
  ],
  '/ee': [
    {
      key: 'facebook',
      icon: fbIcon,
      url: 'https://www.facebook.com/EternalEvolutionOfficial'
    },
    {
      key: 'youtube',
      icon: youtubeIcon,
      url: 'https://www.youtube.com/@eternalevolution'
    },
    {
      key: 'discord',
      icon: discordIcon,
      url: 'https://discord.gg/Wh9NaD9Bb7'
    },
    {
      key: 'instagram',
      icon: instagramIcon,
      url: 'https://www.instagram.com/eternalevolution.official/'
    },
    {
      key: 'twitter',
      icon: twitterIcon,
      url: 'https://twitter.com/EternalEvoluti4'
    },
    {
      key: 'tiktok',
      icon: tiktokIcon,
      url: 'https://www.tiktok.com/@eternal_evolution'
    }
  ],
  '/sd2': [
    {
      key: 'facebook',
      icon: fbIcon,
      url: 'https://www.facebook.com/profile.php?id=61552344052434'
    },
    {
      key: 'discord',
      icon: discordIcon,
      url: 'https://discord.gg/rPRDANqms6'
    }
  ]
}

export const COUNTRY_CONFIG: CurrentCountryType[] = [
  // {
  //   key: 'CN',
  //   label: 'i18n-zh'
  // },
  {
    key: 'US',
    label: 'i18n-en'
  },
  {
    key: 'HK',
    label: 'i18n-hk'
  },
  {
    key: 'TW',
    label: 'i18n-tw'
  },
  {
    key: 'MO',
    label: 'i18n-am'
  },
  {
    key: 'RU',
    label: 'i18n-ru'
  },
  {
    key: 'DE',
    label: 'i18n-de'
  },
  {
    key: 'FR',
    label: 'i18n-fr'
  },
  {
    key: 'KR',
    label: 'i18n-ko'
  },
  {
    key: 'TH',
    label: 'i18n-th'
  },
  {
    key: 'BR',
    label: 'i18n-br'
  },
  {
    key: 'JP',
    label: 'i18n-ja'
  },
  {
    key: 'OTHER',
    label: 'i18n-ot'
  }
]

export const LANGUAGE_CONFIG_MAP: CurrentLanguageType[] = [
  // {
  //   key: 'zh',
  //   label: '中文'
  // },
  {
    key: 'tw',
    label: '繁體中文'
  },
  {
    key: 'en',
    label: 'English'
  },
  {
    key: 'ru',
    label: 'Русский'
  },
  {
    key: 'de',
    label: 'Deutsch'
  },
  {
    key: 'fr',
    label: 'Français'
  },
  {
    key: 'ko',
    label: '한국어'
  },
  {
    key: 'th',
    label: 'แบบไทย'
  },
  {
    key: 'br',
    label: 'Português'
  },
  {
    key: 'jp',
    label: '日本語'
  }
]

export const DICT_VIP_ICONS: any = {
  vip1: v1Icon,
  vip2: v2Icon,
  vip3: v3Icon,
  vip4: v4Icon,
  vip5: v5Icon,
  vip6: v6Icon,
  vip7: v7Icon,
  vip8: v8Icon,
  vip9: v9Icon,
  vip10: v10Icon,
  vip11: v11Icon,
  vip12: v12Icon,
  vip13: v13Icon,
  vip14: v14Icon,
  vip15: v15Icon,
  vip16: v16Icon
}
